export default "__VITE_ASSET__DUSRPKNP__"